<div class="container">
  <div class="col-md-5 mx-auto form-box">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
      <div class="box-title">
        <strong>Change Password </strong>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{'is-invalid': !changePasswordForm.get('oldPassword').valid && changePasswordForm.get('oldPassword').touched,
              'is-valid': changePasswordForm.get('oldPassword').valid && changePasswordForm.get('oldPassword').touched} ">
          <input matInput formControlName="oldPassword" type="password" npDetectFocus #ipOP="detectFocus" placeholder="Old Password">
        </mat-form-field>
        <div *ngIf="!changePasswordForm.get('oldPassword').valid && changePasswordForm.get('oldPassword').touched && !ipOP.isFocus">
          <p class="error-message">Please input information here</p>
        </div>
      </div>
      <div class="form-group">
        <mat-form-field [ngClass]="{
              'is-invalid': (!changePasswordForm.get('newPassword').valid && changePasswordForm.get('newPassword').touched && !ipNP.isFocus) || (changePasswordForm.hasError('passnotmatch') && changePasswordForm.get('confirmNewPassword').value && changePasswordForm.get('newPassword').valid && !ipCNP.isFocus && !ipNP.isFocus),
              'is-valid': changePasswordForm.get('newPassword').valid && !changePasswordForm.hasError('passnotmatch') && !ipCNP.isFocus && !ipNP.isFocus
            }">
          <input matInput formControlName="newPassword" type="password" (keypress)="$event.charCode !== 32" npDetectFocus #ipNP="detectFocus"
            placeholder="New Password">
        </mat-form-field>
        <div *ngIf="changePasswordForm.get('newPassword').hasError('required') && changePasswordForm.get('newPassword').touched && !ipNP.isFocus">
          <p class="error-message">Please enter valid information here</p>
        </div>
        <div *ngIf="changePasswordForm.get('newPassword').hasError('pattern') && !ipNP.isFocus">
          <p class="error-message">
            The password must be at least 8 characters and must contain at least one number, one upper case character and one special
            character.
          </p>
        </div>
      </div>

      <div class="form-group">
        <mat-form-field [ngClass]="{
              'is-invalid': changePasswordForm.hasError('passnotmatch') && changePasswordForm.get('newPassword').valid && changePasswordForm.get('confirmNewPassword').touched && !ipCNP.isFocus && !ipNP.isFocus,
              'is-valid': !changePasswordForm.hasError('passnotmatch') && changePasswordForm.get('newPassword').valid && !ipCNP.isFocus && !ipNP.isFocus
            }">
          <input matInput placeholder="Confirm New Password" formControlName="confirmNewPassword" type="password" npDetectFocus #ipCNP="detectFocus"
          />
        </mat-form-field>
        <div *ngIf="!changePasswordForm.get('confirmNewPassword').value && changePasswordForm.get('confirmNewPassword').touched && changePasswordForm.get('newPassword').valid && !ipCNP.isFocus && !ipNP.isFocus">
          <p class="error-message">Please confirm your new password</p>
        </div>
        <div class="error-message" *ngIf="changePasswordForm.hasError('passnotmatch') && changePasswordForm.get('confirmNewPassword').value && changePasswordForm.get('newPassword').valid && !ipCNP.isFocus && !ipNP.isFocus">
          Password and Confirm password do not match
        </div>
      </div>
      <div class="form-group pt-2">
        <button class="btn btn-block btn-lg" [ngClass]="{
          'btn-inactive': !changePasswordForm.valid,
          'btn-greengo': changePasswordForm.valid
        }" type="submit" npFocusOutClicked>Save</button>
      </div>
    </form>
  </div>
</div>